export const AppName = process.env.REACT_APP_SITE_NAME || "";

export const GetMillisecondsFromMinutes = (minutes: number): number => {
    return minutes * 60000;
};

export const GetMillisecondsFromSeconds = (seconds: number): number => {
    return seconds * 1000;
};
